export const ChatConstant = {
  SECURITY_LEVEL: {
    NORMAL: 0,
    INTERNAL: 1, // origin: RESTRICTED
    RESTRICTED: 2, // origin: CONFIDENTIAL
  }
};
